/**
 * Search bar component with filters for package list.
 */

import { Input, Select, DatePicker, Space, Button, Form } from 'antd';
import { SearchOutlined, ReloadOutlined } from '@ant-design/icons';
import type { Dayjs } from 'dayjs';

const { RangePicker } = DatePicker;

export interface SearchFilters {
  search?: string;
  project?: string;
  file_type?: string;
  date_range?: [Dayjs, Dayjs] | null;
}

interface SearchBarProps {
  projects: Array<{ id: number; name: string }>;
  fileTypes: Array<{ id: number; name: string }>;
  onSearch: (filters: SearchFilters) => void;
  loading?: boolean;
}

export const SearchBar: React.FC<SearchBarProps> = ({
  projects,
  fileTypes,
  onSearch,
  loading = false,
}) => {
  const [form] = Form.useForm<SearchFilters>();

  const handleSearch = () => {
    const values = form.getFieldsValue();
    onSearch(values);
  };

  const handleReset = () => {
    form.resetFields();
    onSearch({});
  };

  return (
    <Form form={form} layout="inline" className="mb-4">
      <Form.Item name="search">
        <Input
          placeholder="搜索包名称/版本/车型"
          prefix={<SearchOutlined />}
          allowClear
          style={{ width: 200 }}
        />
      </Form.Item>

      <Form.Item name="project">
        <Select
          placeholder="选择项目"
          allowClear
          style={{ width: 150 }}
          options={projects.map((p) => ({ value: p.id, label: p.name }))}
        />
      </Form.Item>

      <Form.Item name="file_type">
        <Select
          placeholder="文件类型"
          allowClear
          style={{ width: 120 }}
          options={fileTypes.map((t) => ({ value: t.id, label: t.name }))}
        />
      </Form.Item>

      <Form.Item name="date_range">
        <RangePicker placeholder={['开始日期', '结束日期']} />
      </Form.Item>

      <Form.Item>
        <Space>
          <Button
            type="primary"
            icon={<SearchOutlined />}
            onClick={handleSearch}
            loading={loading}
          >
            搜索
          </Button>
          <Button icon={<ReloadOutlined />} onClick={handleReset}>
            重置
          </Button>
        </Space>
      </Form.Item>
    </Form>
  );
};

export default SearchBar;
